/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type PropsWithChildren } from 'react';
import Lozenge from '@atlaskit/lozenge/lozenge';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import { FormattedMessage } from '@atlassian/jira-intl';

import { fg } from '@atlassian/jira-feature-gating';
import { useIsPremiumLozengeVisible } from './useIsPremiumLozengeVisible.tsx';

export const PremiumLozenge = ({ children }: PropsWithChildren): React.JSX.Element => {
	const isVisible = useIsPremiumLozengeVisible();

	return isVisible ? (
		<Tooltip
			content={
				<FormattedMessage
					id="polaris.premium-lozenge.tooltip"
					defaultMessage="This is a Premium plan feature"
					description="Tooltip text for premium plan features"
				/>
			}
		>
			<Lozenge
				appearance={fg('platform-dst-lozenge-tag-badge-visual-uplifts') ? 'discovery' : 'new'}
			>
				<FormattedMessage
					id="polaris.premium-lozenge.label"
					defaultMessage="Premium"
					description="Text displayed in the premium plan lozenge"
				/>
			</Lozenge>
		</Tooltip>
	) : (
		<>{children}</>
	);
};
